<div class="modal-dialog" *ngIf="!disputInvFlag">
    <div class="modal-content">
     
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="close()"></button>
      </div>


    <div class="modal-body">
        <div class="grid-structure" >              
            <div class="row" *ngFor="let rejectReason of rejectReasons">    
            
                    <div class="col-2" ><input type="radio" [(ngModel)]="selectedReason"></div>
                    <div class="col-10" ><span>{{rejectReason.disc}}</span></div>                
        
               
            </div>
        </div>
    </div>
    
    <div class="modal-footer">
        <div class="row button-list">    
            <div class="col-6">
                <button class="btn fis-btn" (click)="close()">
                    {{ 'LABELS.CANCEL' | translate}}
                </button>
            </div>
            <div class="col-6">
                <button  class="btn fis-btn" appActionButton (click)="submitReason(selectedReason)">
                    {{ 'LABELS.OK' | translate}}
                </button>
            </div>
        </div>  
    </div>
  
  </div>
</div>





<div class="disputedInvoiceContainer" *ngIf="disputInvFlag">
        <ion-content >              
            <ion-col >    
                <ion-row *ngFor="let dispute of disputedInvoiceList">
                    <ion-col size="2"><input type="radio" [(ngModel)]="selectedReason" [value]='dispute'></ion-col>
                    <ion-col size="10"><span>{{dispute.description}}</span></ion-col>                
                </ion-row>
               
            </ion-col>
        </ion-content>
        <ion-row>    
                <ion-col class="ion-text-right">
                    <ion-button class="btn fis-btn" (click)="close()">
                        {{ 'LABELS.CANCEL' | translate}}
                    </ion-button>
                </ion-col>
                <ion-col class="ion-text-left">
                    <ion-button  class="btn fis-btn" appActionButton appThrottleClick (throttleClick)="submitDisputedInv(selectedReason)"
                    [throttleTime]="700">
                    {{ 'LABELS.OK' | translate}}
                    </ion-button>
                </ion-col>
            </ion-row>  
        </div>



<div class="modal-dialog" *ngIf="disputInvFlag">
    <div class="modal-content">
     
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="close()"></button>
      </div>


    <div class="modal-header">
        <h4 class="modal-title" id="myCenterModalLabel">{{ 'LABELS.PAYEX_PRIVATE_LIMITED' | translate }}</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
  
    <div class="modal-body"></div>
    
    <div class="modal-footer"></div>
  
  </div>
</div>